import { Breakpoint, type SliderConfig } from '@jsmdg/yoshi';

type ConfigType = {
    [key in Breakpoint]: SliderConfig;
};

export const productSliderConfig: ConfigType = {
    [Breakpoint.XL]: {
        spaceBetween: 20,
        slidesPerView: 4,
        slidesPerGroup: 4,
        showPagination: true,
        showNavigation: true,
    },
    [Breakpoint.LG]: {
        spaceBetween: 20,
        slidesPerView: 4,
        slidesPerGroup: 4,
        showPagination: true,
        showNavigation: true,
    },
    [Breakpoint.MD]: {
        spaceBetween: 20,
        slidesPerView: 4,
        slidesPerGroup: 4,
        showPagination: true,
        showNavigation: true,
    },
    [Breakpoint.SM]: {
        spaceBetween: 20,
        slidesPerView: 3,
        slidesPerGroup: 3,
        showPagination: true,
        showNavigation: true,
    },
    [Breakpoint.XS]: {
        spaceBetween: 20,
        slidesPerView: 3,
        slidesPerGroup: 3,
        showPagination: false,
        showNavigation: false,
    },
    [Breakpoint['2XS']]: {
        spaceBetween: 12,
        slidesPerView: 2.7,
        slidesPerGroup: 1,
        showPagination: false,
        showNavigation: false,
    },
    [Breakpoint['3XS']]: {
        spaceBetween: 12,
        slidesPerView: 2.7,
        slidesPerGroup: 1,
        showPagination: false,
        showNavigation: false,
    },
};
